import { use } from 'react'
import { VueIsland } from '@/react/bridge/VueIsland'
import { loadIsland, type IslandName } from './registry'

/** A named Vue island in the React tree. Suspends while its chunk loads; wrap it in <Suspense>. */
export function Island({ name, props }: { name: IslandName; props?: Record<string, unknown> }) {
  const component = use(loadIsland(name))
  return <VueIsland component={component} props={props} className="vue-island-root" />
}
